module.exports = __webpack_public_path__ + "img/BLANCO_Learning.b07f2f84.png";